import { Injectable } from '@angular/core';
import { Action, createSelector, State, StateContext } from '@ngxs/store';
import { CacheDataActions } from './cache-data.actions';
import { Page } from '../../model/local/pagination/page';
import SetCachedData = CacheDataActions.SetCachedData;
import ClearCachedData = CacheDataActions.ClearCachedData;

export interface CacheDataStateModel {
  criteria: Record<string, any>;
  data: Record<string, Page<unknown>>;
  cachedAt: Record<string, string>;
}

@State<CacheDataStateModel>({
  name: 'cache_data',
})
@Injectable()
export class CacheDataState {
  static getDataByKey(key: string) {
    return createSelector([CacheDataState], (state: CacheDataStateModel) => {
      return state.data?.[key];
    });
  }

  static getCriteriaByKey(key: string) {
    return createSelector([CacheDataState], (state: CacheDataStateModel) => {
      return state.criteria?.[key];
    });
  }

  static getCachedAt(key: string) {
    return createSelector([CacheDataState], (state: CacheDataStateModel) => {
      return state.cachedAt?.[key] ? new Date(state.cachedAt[key]) : null;
    });
  }

  @Action(SetCachedData)
  setCachedData(ctx: StateContext<CacheDataStateModel>, action: SetCachedData) {
    const state = ctx.getState();
    ctx.patchState({
      data: { ...state.data, [action.key]: action.data },
      criteria: { ...state.criteria, [action.key]: action.criteria },
      cachedAt: { ...state.cachedAt, [action.key]: new Date().toISOString() },
    });
  }

  @Action(ClearCachedData)
  clearCachedData(
    ctx: StateContext<CacheDataStateModel>,
    { key }: ClearCachedData
  ) {
    const state = ctx.getState();

    const { [key]: _, ...newPage } = state.data;
    const { [key]: __, ...newCriteria } = state.criteria;
    const { [key]: ___, ...newCachedAt } = state.cachedAt;

    ctx.setState({
      ...state,
      data: newPage,
      criteria: newCriteria,
      cachedAt: newCachedAt,
    });
  }

  @Action(CacheDataActions.InvalidateCache)
  invalidateCache(
    ctx: StateContext<CacheDataStateModel>,
    { key }: CacheDataActions.InvalidateCache
  ) {
    const state = ctx.getState();

    const { [key]: ___, ...newCachedAt } = state.cachedAt;

    ctx.setState({
      ...state,
      cachedAt: newCachedAt,
    });
  }
}
